import { MinMaxValidatorConfig, ValdrValidator } from '@app/valdr/models';
import { numberValidator } from '@app/valdr/validators/length-validator';
import * as R from 'ramda';

export const maxValidator: ValdrValidator = R.curry(({value: maxValue}: MinMaxValidatorConfig, value: any) =>
  numberValidator(R.gte(maxValue), value)
);
